import { LOCALE } from '@foxrenderfarm/internals'
import { LocaleClass } from '../../utils'
import { Anchor, EmailItem, FloatIcon, Wrapper } from './atoms'
import { ArrowIcon } from './svg/arrow-icon'
import { EmailIcon } from './svg/email-icon'
import { WhatsAppIcon } from './svg/whatsapp-icon'
import React, { useEffect, useState } from 'react'
import { useMedia } from 'use-media'

export const FloatBar = () => {
  const isMobile = useMedia({ maxWidth: 600 })
  const [email, setEmail] = useState('')

  useEffect(() => {
    const { resEmail } = getEmailAndSkype(window.location.pathname)
    setEmail(resEmail)
  }, [])

  const getEmailAndSkype = (pathname: string) => {
    const currentLocale = LocaleClass.getCurrentLocaleName(pathname)
    const resEmail = LocaleClass.isEqualLocale(currentLocale, LOCALE.ES)
      ? 'quique@foxrenderfarm.com'
      : 'service@foxrenderfarm.com'
    return { resEmail }
  }

  const backToTop = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation()
    document.documentElement.scrollTo({ top: 0 })
  }

  return (
    <Wrapper>
      <FloatIcon $hoverBgColor='#fff' $hoverSvgColor='#F3512B' onClick={backToTop}>
        <ArrowIcon />
      </FloatIcon>
      {!isMobile && (
        <>
          <FloatIcon $hideInMobile>
            <a
              href='https://api.whatsapp.com/send/?phone=8618124758259&text=Hello.May%20i%20help%20you?'
              target='_blank'
              rel='noopener noreferrer nofollow'
              aria-label='whatsapp'
            >
              <WhatsAppIcon />
            </a>
          </FloatIcon>
          <EmailItem $hideInMobile>
            <EmailIcon />
            <Anchor href={`mailto:${email}`}>E-mail: {email}</Anchor>
          </EmailItem>
        </>
      )}
    </Wrapper>
  )
}
